import { Modal, Text, VisuallyHidden } from "@mantine/core";

import { SHORTCUTS, capText, type KeyCap } from "./keys";
import classes from "./editor.module.css";

/** A row's keys as live's small grey caps. */
export function KeyCaps({
  keys,
  mac,
  plain = false,
}: {
  keys: readonly KeyCap[];
  mac: boolean;
  /** Live's context menus show the keys as plain grey glyphs ("⌘ C", "⇧ ⌘ S"), not caps. */
  plain?: boolean;
}) {
  if (plain) {
    return <kbd className={classes.menuKeys}>{keys.map((key) => capText(key, mac)).join(" ")}</kbd>;
  }
  return (
    <span className={classes.keyCaps}>
      {keys.map((key) => (
        <kbd key={key} className={classes.keyCap}>
          {capText(key, mac)}
        </kbd>
      ))}
    </span>
  );
}

/**
 * Live's "Shortcuts" (the header's keyboard icon, `editor-depth/02`): three columns, Globe,
 * Timeline and Canvas, each row a name and its keys; a row the editor does not answer is grey.
 */
export function ShortcutsModal(props: { opened: boolean; onClose: () => void; mac: boolean }) {
  const { opened, onClose, mac } = props;
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Shortcuts"
      size={900}
      centered
      classNames={{ title: classes.shortcutsTitle, body: classes.shortcutsBody }}
    >
      {SHORTCUTS.map((group) => (
        <section key={group.title} className={classes.shortcutColumn} aria-label={group.title}>
          <Text className={classes.shortcutGroup}>{group.title}</Text>
          <ul className={classes.shortcutRows}>
            {group.rows.map((row) => (
              <li key={row.label} className={classes.shortcutRow} data-works={row.works}>
                <span>
                  {row.label}
                  {row.works ? null : <VisuallyHidden> (not available)</VisuallyHidden>}
                </span>
                <KeyCaps keys={row.keys} mac={mac} />
              </li>
            ))}
          </ul>
        </section>
      ))}
    </Modal>
  );
}
